/* eslint-disable */
import React, { useLayoutEffect } from 'react';
import { Provider } from 'react-redux';

import { ThemeProvider } from './ThemeContext';

// import { ServiceWorkerProvider } from '@shared/context/ServiceWorkerContext';

import store from '@/store';
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', {
  weekStart: 1,
});
// Было добавленно определение withResolvers для старых версий браузера по задаче https://kampus.atlassian.net/browse/KAM-5273

if (typeof Promise.withResolvers === 'undefined' && window) {
  window.Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const Root = () => {
  useLayoutEffect(() => {
    //Ручка для редиректа, после авторизации
    if (!document.location.pathname.includes('/user-login')) {
      const currentSearchParams = document.location.search;
      const param = new URLSearchParams(currentSearchParams);

      const skillIdsParam = param?.get('skillids') ? `?skillids=${param?.get('skillids')}` : '';

      localStorage.setItem('currentRedirect', document.location.pathname + skillIdsParam);
    }
  }, []);

  return (
    // <ServiceWorkerProvider>
    <Provider store={store}>
      <ThemeProvider />
    </Provider>
    // </ServiceWorkerProvider>
  );
};

export default Root;
